import { AgencyTypesFetchItem } from '../types';

export const AgencyTypes: AgencyTypesFetchItem[] = [
  { id: 'HomeHealth', name: 'Home Health' },
  { id: 'Staffing', name: 'Staffing' },
  { id: 'Hospice', name: 'Hospice' },
  { id: 'NonMedicalHomeCare', name: 'Non-Medical Home Care' },
  { id: 'TravelNursing', name: 'Travel Nursing' },
];
